import dayjs from 'dayjs';

import { addNotify } from 'features/notify';

import { getErrorMessage } from 'shared/helpers/getErrorMessage';

const actionTypes = {
  ACTION_PROCESSING: 'ranking/ACTION_PROCESSING',
  GET_RANKINGS: 'ranking/GET_RANKINGS',
  SET_WITH_RANKING: 'ranking/SET_WITH_RANKING',
  GET_RUBYPLAY_RANKINGS: 'ranking/GET_RUBYPLAY_RANKINGS',
  GET_PRAGMATIC_SLOTS_RANKINGS: 'ranking/GET_PRAGMATIC_SLOTS_RANKINGS',
  GET_PRAGMATIC_LIVE_RANKINGS: 'ranking/GET_PRAGMATIC_LIVE_RANKINGS',
};

function getAgentsRanking(params) {
  return async (dispatch, getState, extra) => {
    const { api } = extra;
    const { locale } = getState().locale;

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const response = await api.agentAdmin.getRankings(params);

    if (response.success) {
      dispatch({
        type: actionTypes.GET_RANKINGS,
        payload: response.data,
      });
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }

    dispatch({
      type: actionTypes.ACTION_PROCESSING,
      payload: false,
    });
  };
}

function getRubyPlayAgentsRanking(params) {
  return async (dispatch, getState, extra) => {
    const { api } = extra;
    const { locale } = getState().locale;

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const response = await api.agentAdmin.getRubyPlayRanking(params);

    if (response.success) {
      dispatch({
        type: actionTypes.GET_RUBYPLAY_RANKINGS,
        payload: response.data,
      });
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }

    dispatch({
      type: actionTypes.ACTION_PROCESSING,
      payload: false,
    });
  };
}

function getPragmaticAgentsRanking({ date, type }) {
  return async (dispatch, getState, extra) => {
    const { api } = extra;
    const { locale } = getState().locale;

    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const response = await api.agentAdmin.getPragmaticRanking({ date, type });

    if (response.success) {
      dispatch({
        type: type === 'pragmatic-live-casino' ? actionTypes.GET_PRAGMATIC_LIVE_RANKINGS : actionTypes.GET_PRAGMATIC_SLOTS_RANKINGS,
        payload: response.data,
      });
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }

    dispatch({
      type: actionTypes.ACTION_PROCESSING,
      payload: false,
    });
  };
}

export { actionTypes, getAgentsRanking, getRubyPlayAgentsRanking, getPragmaticAgentsRanking };
